import { FC, MouseEvent, SVGProps, memo } from 'react';
import { Wrapper, ComplexWrapper } from './svg.styled';

export interface StylePropsComplex {
  color?: string;
  subColor?: string;
  hoverColor?: string;
  subHoverColor?: string;
  cursor?: string;
  //поворачивает на 180 градусов
  isMirror?: boolean;
  //При необходимости повернуть иконку не зеркально
  deg?: number;
  //Значение width/height обёртки в css. На случай необходимости изменения размера компонента вместо дефолтных 16px
  size?: string;
}

export interface Props {
  //цвета для картинки
  props?: StylePropsComplex;
  //сама картинка
  src: FC<SVGProps<SVGSVGElement>>;
  //определяет что картинка состоит из двух векторных элементов (path обёрнуты в группу <g>)
  complex?: boolean;
  //onClick на иконку
  action?: (e: MouseEvent<HTMLDivElement>) => void;
}

/** в src передаём импортированную картинку svg следующим образом:
 * import { ReactComponent as IconName } from '../assets'
 *  <SVG
      src={IconName}
      props={{
              color: 'red',
              hoverColor: 'blue',
              subColor: 'violet',
              subHoverColor: 'yellow',
            }}
      complex
    />
 **/

export const SVG = memo(({ props = {}, src, complex, action }: Props) => {
  const Icon = src;

  return (
    <>
      {complex ? (
        <ComplexWrapper {...props} onClick={action}>
          <Icon width="100%" height="100%" />
        </ComplexWrapper>
      ) : (
        <Wrapper {...props} onClick={action}>
          <Icon width="100%" height="100%" />
        </Wrapper>
      )}
    </>
  );
});
